module.exports = __webpack_public_path__ + "static/media/wastelogo.f9211a03.svg";